//引入 axios
import axios from "axios";
import { ElMessage, ElMessageBox } from 'element-plus';
import { getUrlParam, setCookie, getCookie } from "@/utils/util"
import { login,logout } from '@/api/login.js'


let code = getUrlParam('code')
if (code != null) {
    setCookie('code', code)
}

/*
// 是否显示重新登录
export let isRelogin = { show: false };
*/

const http = axios.create({
    baseURL: `${import.meta.env.VITE_BASE_API}`,
    timeout: 120000,
    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
    }
})

// 数据请求拦截
http.interceptors.request.use((config) => {
	if (import.meta.env.VITE_ENV != 'prod'){
		console.log(JSON.stringify(config.data))
	}
    if ((config.url.indexOf('excel') > -1 && config.url.indexOf('/excel/') == -1)||(config.url.indexOf('Excel') > -1)) {
        config.responseType = 'blob'
    }
    return config;
    /*
    const isAuthenticated = false
    // const isAuthenticated = getCookie('e2mf')==''?true:false// 校验用户是否登录
    console.log('校验是否登录')
    if( isAuthenticated ){ // 验证是否登录
    	if (!isRelogin.show) {
    		isRelogin.show = true;
    		ElMessageBox.confirm(
    			'登录状态已过期，您可以继续留在该页面，或者重新登录',
    			'系统提示',{
    				confirmButtonText: '重新登录',
    				cancelButtonText: '取消',
    				type: 'warning',
    			}
    		).then(() => {
    			isRelogin.show = false;
    			window.location.href = 'https://testu2.staff.xdf.cn/e2api/e2/login?x3id='+import.meta.env.VITE_X3ID+'&state='+(new Date()).valueOf()+'&returnUrl='+window.location.href
    		}).catch(() => {
    			isRelogin.show = false;
    		});
    	}
    }else{
    	return config;
    }
    */
}, (error) => {
    return Promise.reject(error);
});

// 返回响应数据拦截
http.interceptors.response.use((res) => {
    const data = res.data;
    // console.log(res.config.responseType)
    // console.log(res.headers['content-disposition'])
    // 状态码为 2xx 范围时都会调用该函数，处理响应数据
    if (res.status === 200) {
        if (!res.data.type) {
            const code = data.code;
            if (code != '2001') {
                if (code == '3001') {
                    // 处理需要重新登录的情况
                    login()
                    // logout()
                } else {
                    ElMessage({
                        type: 'error',
                        message: data.msg,
                        showClose: true
                    });
                }
            }
        }
        if (res.config.responseType == 'blob') {
            return Promise.resolve(res);
        } else {
            return Promise.resolve(data);
        }
    }
}, (error) => {
    ElMessage({
        type: 'error',
        message: '服务器内部报错，请联系管理员',
        showClose: true
    });
    /*
    if (error.response.status) {
    	// 状态码超过 2xx 范围时都会调用该函数，处理错误响应
    	switch (error.response.status) {
    		case 404:
    			ElMessage({
    				type: 'error',
    				message: '请求路径找不到！',
    				showClose: true
    			});
    			break;
    		case 502:
    			ElMessage({
    				type: 'error',
    				message: '服务器内部报错，请联系管理员',
    				showClose: true
    			});
    			break;
    		default:
    			ElMessage({
    				type: 'error',
    				message: '系统报错，请联系管理员',
    				showClose: true
    			});
    			break;
    	}
    }*/
    return Promise.reject(error);
});
export default http;